var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gocc",attrs:{"id":"app"}},[_c('router-view'),(_vm.response.has)?_c('response-bar',{staticClass:"gocc__page__response",attrs:{"settings":{
            status: _vm.response.type,
            message: _vm.response.message
        },"message":_vm.response.message}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }